import React from 'react';
import './Badge.css';

const Badge = ({ children, variant = 'default', size = 'md', className = '' }) => {
  return (
    <span className={`rb-badge rb-badge-${variant} rb-badge-${size} ${className}`}>
      {children}
    </span>
  );
};

export default Badge;
